/**
 * Title-case enum-like tokens for hub chips (e.g. VALIDATED → Validated).
 */
export function formatHubChipLabel(value: string | null | undefined): string {
  if (!value) return "";
  const normalized = value.trim().replaceAll("_", " ").toLowerCase();
  if (!normalized) return value;
  return normalized.replace(/\b\w/g, (ch) => ch.toUpperCase());
}
